// extracted by mini-css-extract-plugin
export var copyable = "_h-1";
export var explainable = "_h-0";
export var negative = "_h-2";
export var positive = "_h-3";